module.exports = __webpack_public_path__ + "media/theme/icons-6d64bee3.woff";